// src/views/Operaciones/Facturacion/VerFacturasGeneradas.jsx
import React, { useEffect, useState } from "react";
import { appFetchJson } from "../../../utils/http";
import apiRoutes from "../../../api/apiRoutes";

export default function VerFacturasGeneradas({ id, onClose = () => {} }) {
  // =========================
  // ESTADOS
  // =========================
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [factura, setFactura] = useState(null);

  // =========================
  // CARGA DETALLE
  // =========================
  useEffect(() => {
    if (!id) return;

    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError("");

      try {
        const data = await appFetchJson(
          apiRoutes.facturas.detail(id)
        );

        if (!cancelled) {
          setFactura(data);
        }
      } catch (err) {
        console.error("Error al cargar factura:", err);
        if (!cancelled) {
          setError(err.message || "Error al cargar la factura.");
          setFactura(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [id]);

  // =========================
  // FILAS A MOSTRAR
  // =========================
    const rows = [
        ["Cliente", factura?.cliente],
        ["N° Liquidación", factura?.numeroLiquidacion],
        ["Factura por Cliente", factura?.facturaCliente],
        ["Estado", factura?.estado],
        ["Número", factura?.numero],
        ["Producto", factura?.producto],

        ["Cantidad", formatNumber(factura?.qnProducto)],
        ["Precio", formatNumber(factura?.valorPrecio)],
        ["Valor Monto Fac", formatNumber(factura?.valorMontoFac)],
        ["Valor IVA Fac", formatNumber(factura?.valorIvaFac)],

        ["Fecha Factura", factura?.fechaFactura],
    ];


  // =========================
  // RENDER
  // =========================
  return (
    <div className="modal-backdrop">
      <div className="modal-panel-lg">
        {/* HEADER */}
        <div className="modal-header">
          <h2 className="section-title">Detalle de Factura</h2>
        </div>

        {/* BODY */}
        <div className="modal-body">
          {loading && (
            <div className="py-6 text-center text-gray-600">
              Cargando…
            </div>
          )}

          {!loading && error && (
            <div className="py-6 text-center text-red-600">
              {error}
            </div>
          )}

          {!loading && !error && factura && (
            <div className="form-grid">
              {rows.map(([label, value]) => (
                <Fila key={label} label={label} value={value} />
              ))}
            </div>
          )}
        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <div className="flex justify-end">
            <button className="btn-fil" onClick={onClose}>
              Nueva consulta
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

const numberFmt = new Intl.NumberFormat("es-PY", {
  maximumFractionDigits: 0,
  useGrouping: true,
});

function formatNumber(value) {
  if (value === null || value === undefined || value === "") return null;

  // si viene como string con coma/puntos/espacios, normalizamos
  let raw = value;
  if (typeof raw === "string") {
    const cleaned = raw.trim().replace(/\s/g, "");
    // asumimos: "." miles y "," decimales (caso típico)
    raw = cleaned.replace(/\./g, "").replace(",", ".");
  }

  const n = Number(raw);
  if (Number.isNaN(n)) return value;

  return numberFmt.format(n);
}

// =========================
// COMPONENTE FILA
// =========================
function Fila({ label, value }) {
  return (
    <div className="form-row">
      <div className="form-label">{label}:</div>
      <div className="value">
        {value !== null && value !== undefined && value !== ""
          ? value
          : <span className="text-gray-400">—</span>}
      </div>
    </div>
  );
}
